import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en/translation.json';
import tr from './locales/tr/translation.json';

i18n
    .use(LanguageDetector) // Tarayıcı dilini algılar
    .use(initReactI18next) // react-i18next bağlayıcısını kullan
    .init({
        resources: {
            en: { translation: en },
            tr: { translation: tr }
        },
        fallbackLng: 'en', // Tarayıcı dili desteklenmezse varsayılan dil
        interpolation: {
            escapeValue: false // React zaten XSS koruması sağlar
        }
    });

export default i18n;
